//
//
//
//
//
//
//
//
//
//
//
//

import ImportDialogWidget from "./ImportDialogWidget.vue";

const IMPORT_TYPE_PRODUCT = 2;
const NOT_FOUND_CREATE_NEW = 1;
const NOT_FOUND_SKIP_LINE = 2;

const NOT_FOUND_OPTIONS = [
  { label: "Opprett nytt produkt", value: NOT_FOUND_CREATE_NEW },
  { label: "Hopp over linjen", value: NOT_FOUND_SKIP_LINE }
];

const MAPPING_FIELDS = [
  {
    label: "Produktnr.",
    name: "ProductNumber",
    required: true,
    column: "A",
    errors: {}
  },
  {
    label: "Gtin/EAN",
    name: "Ean",
    column: "B",
    errors: {}
  },
  {
    label: "Strekkode",
    name: "Barcode",
    column: "C",
    errors: {}
  },
  {
    label: "Navn",
    name: "ProductName",
    column: "D",
    errors: {}
  },
  {
    label: "Beskrivelse",
    name: "ProductDescription",
    column: "E",
    errors: {}
  },
  {
    label: "Produkttype",
    name: "Type",
    column: "F",
    errors: {}
  },
  {
    label: "Enhet",
    name: "Unit",
    column: "G",
    errors: {}
  },
  {
    label: "Vekt (KG)",
    name: "Weight",
    column: "H",
    errors: {}
  },
  {
    label: "Tollkode",
    name: "TollCode",
    column: "I",
    errors: {}
  },
  {
    label: "Opprinnelsesland",
    name: "CountryCodeId",
    column: "J",
    errors: {}
  },
  {
    label: "Minpunkt",
    name: "MinimumPoint",
    column: "K",
    errors: {}
  },
  {
    label: "Makspunkt",
    name: "MaximumPoint",
    column: "L",
    errors: {}
  },
  {
    label: "Kalkyle nr",
    name: "PriceCalculationId",
    column: "M",
    errors: {}
  },
  {
    label: "Salgspris (eks. mva.)",
    name: "PriceExVat",
    column: "N",
    errors: {}
  },
  {
    label: "Innkjøpspris",
    name: "CostPrice",
    column: "O",
    errors: {}
  },
  {
    label: "Selvkost",
    name: "FullCost",
    column: "P",
    errors: {}
  },
  {
    label: "Hovedbokskonto (Salg)",
    name: "AccountID",
    required: true,
    column: "Q",
    errors: {}
  },
  {
    label: "Hovedbokskonto (Innkjøp)",
    name: "PurchaseAccountID",
    required: true,
    column: "R",
    errors: {}
  },
  {
    label: "Kjøpsfrekvens (Dager)",
    name: "PurchaseFrequencyDays",
    column: "S",
    errors: {}
  },
  {
    label: "Bruk serienummer (ja/nei)",
    name: "SerialNumberEnabled",
    column: "T",
    errors: {}
  },
  {
    label: "Faktor (minstepris)",
    name: "ConversionFactor",
    column: "U",
    errors: {}
  }
];

const SETTINGS_CONFIG = [
  {
    name: "notFound",
    type: "select",
    label: "Håndtering ved ingen treff",
    options: NOT_FOUND_OPTIONS,
    required: true,
    errorMessage: "Vennligst velg en håndtering ved ingen treff."
  },
  {
    name: "headerLine",
    type: "toggle",
    label: "Overskriftslinje",
    default: true
  },
  {
    name: "activateDeactivatedProducts",
    type: "toggle",
    label: "Aktiver deaktiverte produkter",
    default: false
  }
];

export default {
  components: {
    ImportDialogWidget
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      IMPORT_TYPE_PRODUCT,
      mappingFields: JSON.parse(JSON.stringify(MAPPING_FIELDS)),
      settingsConfig: JSON.parse(JSON.stringify(SETTINGS_CONFIG)),
      description: `
        <p>
          Rutinen leser inn produktinformasjon.
          Utfylte felt skrives over/opprettes. Koblede felt i tabellen
          behandles. Rutinen behandler filer i excel-format.
        </p>
      `
    };
  }
};
